import { PDF_CLEAR_ALL_STATE } from '@app/libs/reactPdfJs/store/actionTypes';
import * as TYPES from '@app/store/actionTypes';
import { TemplateAction } from '@app/store/template/actions';

type TemplateFieldIsInsertingState = boolean;

const initialState: TemplateFieldIsInsertingState = false;

export default function reducer(
  state: TemplateFieldIsInsertingState = initialState,
  action: TemplateAction | { type: typeof PDF_CLEAR_ALL_STATE }
) {
  switch (action.type) {
    case PDF_CLEAR_ALL_STATE:
    case TYPES.TEMPLATE_CLEAR_ALL_STATE:
    case TYPES.TEMPLATE_FIELD_CREATE:
    case TYPES.TEMPLATE_FIELD__CREATION_CANCEL:
      return false;
    case TYPES.TEMPLATE_FIELD_TARGET_SET:
      return true;
    default:
      return state;
  }
}
